export default defineNuxtRouteMiddleware((to) => {
  const path = to.path
  if (path.startsWith('/fr/fr/') || path === '/fr/fr') {
    const fixedPath = path.replace(/^\/fr\/fr/, '/fr')
    const url = fixedPath + (to.search || '') + (to.hash || '')
    return navigateTo(url, { redirectCode: 301 })
  }
})
